import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../lib/utils";

export interface EmptyStateTitleProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export const EmptyStateTitle = ({ className, ref, ...props }: EmptyStateTitleProps) => (
  <div
    ref={ref}
    data-slot="empty-state-title"
    className={cn("text-sm font-semibold leading-snug text-foreground", className)}
    {...props}
  />
);
